import { render } from "./TranslateEducation.vue?vue&type=template&id=58af074a"
import script from "./TranslateEducation.vue?vue&type=script&lang=js"
export * from "./TranslateEducation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__